import StatisticsGuide from './StatisticsGuide';

export default StatisticsGuide;
